<template>
  <section>
    <PageHeading title="Relatórios" :pieces="['Relatórios', 'Vendas']" />

    <div style="padding: 20px">
      <v-row style="gap: 8px">
        <v-col sm="6" md="4">
          <date-picker
            placeholder="Selecione o período"
            v-model="period"
            range
            format="DD/MM/YYYY"
            style="width: 100%"
            @clear="period = null"
          ></date-picker>
        </v-col>
        <v-col>
          <v-btn
            :disabled="!period"
            @click="doFilter(period)"
            color="secondary"
            outlined
            elevation="2"
            :loading="isLoading"
            >Filtrar</v-btn
          >
        </v-col>
        <v-col v-show="orders.length" style="justify-content: flex-end; display: flex;">
          <v-btn
            @click="generateExcel"
            color="secondary"
            outlined
            elevation="2"
            :loading="isExporting"
            >Exportar em Excel</v-btn
          >
        </v-col>
      </v-row>
    </div>

    <v-card>
      <v-card-title>
        Vendas
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar..."
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="isLoading"
        loading-text="Carregando... Por favor aguarde"
        :headers="headers"
        :items="orders"
        :search="search"
        :footer-props="{
          'items-per-page-text':'Itens por página',
          'items-per-page-all-text': 'Todos',
          'items-per-page-options': [10, 20, 50, -1]
        }"
      ></v-data-table>
    </v-card>
  </section>
</template>

<script>
import PageHeading from "@/views/admin/components/PageHeading.vue";
import ExportableMixin from '@/mixins/ExportableMixin.js';
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { format } from "date-fns";

export default {
  name: "SellsReport",
  mixins: [ExportableMixin],
  components: { PageHeading, DatePicker },
  methods: {
    async doFilter([startDate, endDate]) {
      this.$data.rawOrders = [];
      this.$data.orders = [];
      this.$data.isLoading = true;
      startDate.setHours(0);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      endDate.setHours(23);
      endDate.setMinutes(59);
      endDate.setSeconds(59);
      const ordersCollection = firebase.firestore().collection("orders");
      let query = ordersCollection
        .where("status", "==", "done")
        .where("createdAt", ">=", startDate)
        .where("createdAt", "<=", endDate);

      try {
        (await query.get()).docs.forEach((doc) => {
          const docData = { id: doc.id, ...doc.data() };
          this.$data.rawOrders.push(docData);
          this.$data.orders.push({
            customerName: docData.customer.name,
            itemsAmount: parseFloat(docData.amount.itemsAmount).toFixed(2),
            orderAmount: parseFloat(docData.amount.orderAmount).toFixed(2),
            createdAt: format(docData.createdAt.toDate(), "dd/MM/yyyy"),
            supermarket: docData.supermarket.name,
            city: docData.supermarket.city,
            paymentMethod: docData.paymentMethod,
          });
        });
      } catch (e) {
        this.$data.errorReason = e;
        alert(`Erro ao buscar os dados. Tente mais tarde.`);
      }

      this.$data.isLoading = false;
    },
    generateExcel() {
      this.$data.isExporting = true;
      const transformedData = [];
      this.$data.rawOrders.forEach(rawOrder => {
        const IS_TELEGRAM = rawOrder.origin === 'telegram';
        const obj = {};
        obj['Cód Pedido'] = rawOrder.id;
        obj['Data de criação do pedido'] = format(rawOrder.createdAt.toDate(), "dd/MM/yyyy");
        obj['Data da última atualização do pedido'] = format(rawOrder.updatedAt.toDate(), "dd/MM/yyyy");
        obj['Nome do Cliente'] = rawOrder.customer.name;
        obj['Endereço do Cliente'] = `${rawOrder.customer.address}, N ${rawOrder.customer.address_number} - ${rawOrder.customer.district}`;
        obj['CEP do Cliente'] = rawOrder.customer.zipcode;
        obj['Whatsapp'] = IS_TELEGRAM ? '' : rawOrder.customer.id;
        obj['Telegram ID'] = IS_TELEGRAM ? rawOrder.customer.id : '';
        obj['Forma de pagamento'] = rawOrder.paymentMethod;
        obj['Valor do Pedido'] = rawOrder.amount.orderAmount;
        obj['Valor dos Itens'] = rawOrder.amount.itemsAmount;
        obj['Quantidade de itens'] = rawOrder.items.length;
        obj['Nome do picker'] = rawOrder.picker.name;
        obj['Valor da taxa administrativa'] = parseFloat(rawOrder.amount.taxes.administrative);
        obj['Valor da taxa de entrega'] = parseFloat(rawOrder.amount.taxes.distance);
        obj['Supermercado'] = rawOrder.supermarket.name;
        obj['Cidade'] = rawOrder.supermarket.city;

        transformedData.push(obj);
      });
      this.generateXLS(transformedData);
      this.$data.isExporting = false;
    }
  },
  data() {
    return {
      period: null,
      errorReason: null,
      isLoading: false,
      isExporting: false,
      search: "",
      headers: [
        { text: "Cliente", value: "customerName" },
        { text: "Vlr. Itens", value: "itemsAmount" },
        { text: "Vlr. Pedido", value: "orderAmount" },
        { text: "Data de registro", value: "createdAt" },
        { text: "Supermercado", value: "supermarket", sortable: false },
        { text: "Cidade", value: "city", sortable: false },
        { text: "Forma de pag.", value: "paymentMethod" },
      ],
      orders: [],
      rawOrders: []
    };
  },
};
</script>

<style lang="scss">
.v-data-table-header {
  th {
    font-size: 90%;
  }
}

table {
  tr td {
    font-size: 80% !important;
  }
}

.v-data-footer {
  &__select, &__pagination {
    font-size: 1.2rem;
  }
}

.v-data-footer__select .v-select__selections .v-select__selection--comma {
  font-size: 1.2rem;
}
</style>

